import { TypographyCaption } from '@heidi/design-system/typography';
import type { ReactNode } from 'react';

/**
 * Nested panel used inside the inline-approval family for
 * supporting context — the agent's rationale ("Why ask"), an opted-in
 * tool's plain-English summary ("What this does"), and a CUA task's
 * success criteria ("Done when"). Centralises the box chrome and label
 * typography so the sites stay visually identical when a design tweak
 * lands. A white surface with a light hairline border (rather than a
 * filled tint) keeps it quiet against the card.
 */
export interface LabelledContextPanelProps {
  label: ReactNode;
  children?: ReactNode;
}

export const LabelledContextPanel = ({ label, children }: LabelledContextPanelProps) => (
  <div className="flex flex-col gap-1 rounded-md border border-border bg-surface p-3">
    <TypographyCaption className="font-medium text-text-secondary">
      {label}
    </TypographyCaption>
    {children}
  </div>
);
